import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Button from '~components/button';
import { buildAllMatchesSearch } from './newMatchesParams';

import './new-matches-banner.scss';

const NewMatchesBanner = ({ count = 0 }) => {
  const history = useHistory();
  const location = useLocation();

  const handleShowAll = () => {
    history.replace({
      pathname: location.pathname,
      search: buildAllMatchesSearch(location.search),
    });
  };

  return (
    <div className="c-new-matches-banner" role="status">
      <div className="c-new-matches-banner__content">
        <strong className="c-new-matches-banner__title">
          <FormattedMessage
            id="components.listing.new-matches-banner.title"
            defaultMessage="{count, plural, one {# new match} other {# new matches}}"
            values={{ count }}
          />
        </strong>
        <span className="c-new-matches-banner__caption">
          <FormattedMessage
            id="components.listing.new-matches-banner.caption"
            defaultMessage="These profiles recently matched your search."
          />
        </span>
      </div>
      <Button type="button" className="c-btn c-new-matches-banner__action" onClick={handleShowAll}>
        <FormattedMessage
          id="components.listing.new-matches-banner.show-all"
          defaultMessage="Show all matching profiles"
        />
      </Button>
    </div>
  );
};

export default NewMatchesBanner;
